module.exports = __webpack_public_path__ + "static/ucalgary-4144d6b5793ad8e4d41a33a549d102fa.png";